import { createParser } from "nuqs";

export const caseInsensitiveBoolean = createParser({
  parse(queryValue) {
    if (queryValue === null) {
      return null;
    }

    return queryValue.toLowerCase() === "true";
  },
  serialize(value) {
    return value ? "true" : "false";
  },
});
